import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import NewsList from "./NewsList";
import NewsListRecentWork from "./NewsListRecentWork";
import { getAllNews } from "./newsListSlice";
import PageTitle from "../../components/PageTitle";
import { useLocation } from "react-router-dom";

const NewsListPage = () => {
  const dispatch = useDispatch();
  const NewsListData = useSelector((state) => state.newsList.NewsListData);
  const location = useLocation();
  const fullURL = window.location.origin + location.pathname;

  useEffect(() => {
    dispatch(getAllNews());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>{NewsListData?.MetaTitle}</title>
        <meta name="description" content={NewsListData?.MetaDescription} />
        <meta name="keywords" content={NewsListData?.MetaKeywords} />
        <link rel="canonical" href={fullURL} />
      </Helmet>
      <PageTitle
        BannerTitle={"News List"}
        BannerImage={NewsListData?.BannerImage}
      />
      <div className="blog-post">
        <div className="container">
          <div className="row">
            <NewsList />
            {/* <NewsListRecentWork /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsListPage;
